module.exports = __webpack_public_path__ + "static/media/app-intro-1.60df5f78.jpg";